import styled from "styled-components"

export const StyledMikanSpan = styled.span`
  display: ${({ isPunctuationMark }) => (isPunctuationMark ? "inline" : "inline-block")};
  word-break: keep-all;
`
